/**
 * Created by Jie Gao on 2020-09-25.
 */
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Align, Direction, GuiLayout} from "@nolimitcity/slot-launcher/bin/gui/utils/GuiLayout";
import {TweenLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class WixxSlideShowPage extends SlideShowPage {
    private _animation: TimelineSprite;
    private _panel: PIXI.Container;

    constructor(textures: PIXI.Texture[], fps: number = 30, subTexture: PIXI.Texture) {
        super(undefined, undefined);
        this.createAnimationItem(textures, fps);
        this.createRightPanel(subTexture);
        NolimitApplication.events.on(NolimitApplication.RESIZE, () => this.onResize());
    }

    public enable(enable: boolean): void {
        super.enable(enable);
        let delay: number;

        if (enable) {
            delay = ((this._animation.totalFrames > 15) ? 2 : 3);
            this._animation.getAnimation();
            TweenLite.delayedCall((this._animation.totalDuration + delay), () => this._animation.getAnimation());
        } else {
            this._animation.setFrame(0);
        }
    }

    private createAnimationItem(textures: PIXI.Texture[], fps: number): void {
        const animation = new TimelineSprite(textures, fps);
        animation.anchor.set(1, 0.5);
        animation.position.x = -10;
        this.addChild(animation);

        this._animation = animation;
    }

    private createRightPanel(textTexture: PIXI.Texture): void {
        this._panel = new PIXI.Container();
        const textImage: PIXI.Sprite = new PIXI.Sprite(textTexture);
        textImage.blendMode = PIXI.BLEND_MODES.ADD;

        this._panel.pivot.set(this._panel.width * 0.5, this._panel.height * 0.5);
        this._panel.addChild(textImage);

        GuiLayout.align([textImage], 10, Align.CENTER, Direction.VERTICAL);

        this._panel.y = -(this._panel.height * 0.5);
        this.addChild(this._panel);
    }

    onResize() {
        const xPos: number = NolimitApplication.isLandscape ? 0 : -50;
        this._panel.position.x = xPos;
    }
}